var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InfoUserTraining"},[_c('div',{staticClass:"d-flex-between-center"},[_c('p',{staticClass:"f-16 f-c-midgrey f-Overpass"},[_vm._v(_vm._s(_vm.header))]),_c('p',{staticClass:"f-16 f-c-black f-Overpass"},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }